import React from 'react';
import { Box, VStack, FormControl, FormLabel, Input, Switch, Button } from '@chakra-ui/react';
import LuaScriptList from './LuaScriptList';

const Settings = () => {
  return (
    <Box>
      <VStack spacing={4} align="stretch">
        <FormControl>
          <FormLabel>Site Name</FormLabel>
          <Input placeholder="Enter site name" />
        </FormControl>
        <FormControl display="flex" alignItems="center">
          <FormLabel htmlFor="maintenance-mode" mb="0">
            Maintenance Mode
          </FormLabel>
          <Switch id="maintenance-mode" />
        </FormControl>
        <FormControl display="flex" alignItems="center">
          <FormLabel htmlFor="user-registration" mb="0">
            Allow User Registration
          </FormLabel>
          <Switch id="user-registration" />
        </FormControl>
        <Button colorScheme="blue">Save Settings</Button>
        <LuaScriptList></LuaScriptList>
       
      </VStack>
    </Box>
  );
};

export default Settings;